import { Helmet } from '@dr.pogodin/react-helmet';
import { skipJaneTitle, useRuntimeConfig } from '@iheartjane/runtime-config';
import { statePostalCode } from '@iheartjane/utils';
import lowerCase from 'lodash-es/lowerCase';

import { getCanonicalPath } from '@jane/shared-ecomm/components';
import { useMenu } from '@jane/shared-ecomm/providers';
import { useEcommApp } from '@jane/shared/providers';
import { appendDispensaryToStoreName } from '@jane/shared/util';

/**
 * Used in conjunction with MenuSeo
 * Menu pages share page description and structured data,
 * but have distinct titles and canonical links
 */

export const MenuPageSeo = ({
  path,
  title,
}: {
  path: string;
  title: string;
}) => {
  const { isIframe } = useEcommApp();
  const runtimeConfig = useRuntimeConfig();
  const { isFramelessEmbedMode, isBoostForAll } = runtimeConfig;
  const { store } = useMenu();
  const pageCanonical = getCanonicalPath({
    inIframe: isIframe,
    isBoostWp: isFramelessEmbedMode && !isBoostForAll,
    pagePath: path,
  });
  const pageTitle = `Shop ${lowerCase(title)} cannabis products | ${appendDispensaryToStoreName(store.name, ' Dispensary')} ${store.city}, ${statePostalCode(store.state)}`;

  const skipTitle = skipJaneTitle(runtimeConfig);

  return (
    <Helmet>
      {!skipTitle && <title>{pageTitle}</title>}
      {!skipTitle && <meta property="og:title" content={pageTitle} />}
      {!skipTitle && <meta property="twitter:title" content={pageTitle} />}

      {/** Canonical & og:url are set on the server for boost4all menus https://github.com/janetechinc/iheartjane/blob/b36d47cefe38578e391ecdd3d33addf12bd1f425/api/app/lib/boost/compilation/compile.rb#L35 */}
      {!isBoostForAll && <link rel="canonical" href={pageCanonical} />}
      {!isBoostForAll && <meta property="og:url" content={pageCanonical} />}
      <meta property="twitter:url" content={pageCanonical} />
    </Helmet>
  );
};
